import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

export const NotificationsPlacholder = (props: IContentLoaderProps) => {
  return (
    <ContentLoader
      viewBox="0 0 512 124"
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
      {...props}
    >
      <circle cx="48" cy="48" r="24" />;
      <rect x="88" y="24" rx="8" ry="8" width="400" height="16" />
      <rect x="88" y="52" rx="8" ry="8" width="240" height="16" />
    </ContentLoader>
  );
};

export const NotificationsActionsPlaceholder = (props: IContentLoaderProps) => {
  return (
    <ContentLoader
      viewBox="0 0 480 36"
      style={{ height: '36px', alignSelf: 'baseline' }}
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
      {...props}
    >
      <rect x="0" y="0" rx="18" ry="18" width="70" height="36" />
      <rect x="78" y="0" rx="18" ry="18" width="70" height="36" />
      <rect x="156" y="0" rx="18" ry="18" width="70" height="36" />
    </ContentLoader>
  );
};
